import axios from "axios";
import Cookies from "js-cookie";
import { CONFIG } from "../../config";
export const getCompletedLessonIDs = async (coursesDetails) => {
	try {
		const authToken = Cookies.get("authToken");
		const response = await axios.get(
			`${CONFIG.COURSEURL}/api/v2/student-progress/find-completed-video-ids/${coursesDetails.studentId}/${coursesDetails.courseId}/${coursesDetails.subCourseId}`,
			authToken ? { headers: { Authorization: `Bearer ${authToken}` } } : undefined
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
